<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>{{ pharmacy.title }}</strong>
                </CCardHeader>
                <CCardBody>
                    <PharmacyTabLinks />
                    <div class="flex mt-2">
                        <ProductFinder
                            business_type="pharmacy"
                            :business_id="$route.params.id"
                            @select="selectDrug"
                        />
                    </div>
                    <CRow class="pl-3 pb-3" />
                    <CRow class="pl-3 pb-3">
                        <table class="table">
                            <thead>
                                <th><input v-model="areTableItemsDraggable" type="checkbox" /></th>
                                <th>Название</th>
                                <th>Цена</th>
                                <th></th>
                            </thead>
                            <component
                                :is="areTableItemsDraggable ? 'draggable': 'tbody'"
                                v-model="drugs"
                                tag="tbody">
                                <tr v-for="drug in drugs" :key="drug.id">
                                    <td>
                                        <CIcon
                                            :height="24"
                                            :content="$options.icons.cilCursorMove"
                                            class="cursor-pointer"
                                        />
                                    </td>
                                    <td>
                                        <CLink
                                            :to="`/pharmacies/${pharmacy.id}/drugs/${drug.id}`"
                                        >{{ drug.title }}</CLink
                                        >
                                    </td>
                                    <td>
                                        <p>{{ drug.price }}</p>
                                        <!-- <p class="text-gray-400 text-xs">{{ drug.weight }} г</p> -->
                                    </td>
                                    <td>
                                        <input
                                            v-model="drug.enabled"
                                            type="checkbox"
                                            @change="updateDrug(drug)"
                                        />
                                    </td>
                                </tr>
                            </component>
                        </table>
                        <CPagination
                            class="mt-4"
                            :active-page.sync="activePage"
                            :pages="totalPages"
                            align="center"
                        />
                    </CRow>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="create"
                    >Создать</CButton
                    >
                    <CButton
                        color="info"
                        class="mr-3"
                        @click="save"
                    >Сохранить порядок</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import draggable from 'vuedraggable';
    import { cilCursorMove } from '@coreui/icons';

    import ProductFinder from '@/components/ProductFinder';
    import PharmacyTabLinks from '@/components/pharmacies/PharmacyTabLinks';
    import { ITEMS_PER_PAGE } from '../../utils/views';

    export default {
        name: 'PharmacyGoods',

        components: {
            PharmacyTabLinks,
            draggable,
            ProductFinder,
        },

        data() {
            return {
                pharmacy: {},
                drugs: [],
                totalPages: 0,
                areTableItemsDraggable: true
            };
        },

        computed: {
            activePage: {
                get() {
                    return parseInt(this.$route.query.page) || 1;
                },
                async set(v) {
                    const query = { page: v };
                    this.$router.push({ query });
                },
            },
        },

        watch: {
            activePage: 'fetchList',
        },

        async created() {
            this.fetchEntity();
            this.fetchList();
        },

        icons: {
            cilCursorMove,
        },

        methods: {
            async fetchList() {
                const id = this.$route.params.id;
                const params = { page: this.activePage };
                Vue.axios
                    .get('/pharmacies/' + id + '/drugs', { params })
                    .then(resp => {
                        this.drugs = resp.data.results;
                        this.totalPages = parseInt(resp.data.total / ITEMS_PER_PAGE) + 1;
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка загрузки данных.');
                    });
            },
            async fetchEntity() {
                const id = this.$route.params.id;
                Vue.axios
                    .get('/pharmacies/' + id)
                    .then(resp => {
                        this.pharmacy = resp.data;
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка загрузки данных.');
                    });
            },
            save() {
                // Save order only
                const reorder = [];
                let index = 0;
                this.drugs.forEach(drug => {
                    reorder.push({
                        id: drug.id,
                        position: ++index,
                    });
                });
                Vue.axios
                    .post('/pharmacies/' + this.pharmacy.id + '/drugs/reorder', {
                        reorder: reorder,
                    })
                    .then(resp => {
                        this.$router.push('/pharmacies/' + this.pharmacy.id);
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка сохранения порядка лекарств. ' + err);
                    });
            },

            create() {
                this.$router.push('/pharmacies/' + this.pharmacy.id + '/drugs/create');
            },

            getBadge(status) {
                return status ? 'success' : 'secondary';
            },

            selectDrug(id) {
                this.$router.push('/pharmacies/' + this.pharmacy.id + '/drugs/' + id);
            },
            updateDrug(drug) {
                Vue.axios.put('/pharmacies/' + this.pharmacy.id + '/drugs/' + drug.id, drug)
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка сохранения.');
                    });
            },
        },
    };
</script>
<style lang="scss" scoped>
.table {
    tr {
        td {
            padding: 0 .2rem;

            &:nth-child(2) {
                max-width: 30vw;
            }
        }
    }
}
</style>